import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import { InfoCircleOutlined, } from '@ant-design/icons';
import { Form, Input, Select, DatePicker, message } from 'antd';
import { ExchangeCurrency } from '../../Filters/FilterConditions';
import { FetchDealByAccount, FetchDealDetails } from '../../../../Api/Services/DealApiService';
import { FetchContactDetails, FetchContactByDeal } from '../../../../Api/Services/ContactApiService';


const { Option } = Select;
export async function getDealsyncData(id, profile, disabledDate, latestCurrencySettings, ConvertRates, CurencyDecimalPlace) {
    let result;
    try {
        const dealresponse = await FetchDealDetails(id);
        const response = dealresponse
        if (response?.data?.subtype === "Others") {
            const DealValue = response?.data?.deal_value ? await ExchangeCurrency(Number(response?.data?.deal_value), ConvertRates) : response?.data?.deal_value;
            const revenueStartDate = response?.data?.revenue_start_date !== "" && response?.data?.revenue_start_date !== null ? response?.data?.revenue_start_date : null;
            const revenueEndDate = response?.data?.revenue_end_date !== "" && response?.data?.revenue_end_date !== null ? response?.data?.revenue_end_date : null;
            result = {
                datas: {
                    type: response?.data?.subtype,
                    product: response?.data?.products,
                    service: response?.data?.service
                },
                discount: response?.data?.discount_percentage ? response?.data?.discount_percentage : 0,
                items: [{
                    ItemId: id,
                    name: "Others",
                    type: "Others",
                    value: DealValue,
                    startDate: revenueStartDate,
                    endDate: revenueEndDate,
                    total: DealValue
                }],
                columns: [
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        key: 'name',
                        render: (text, record) => (
                            <Form.Item>
                                <Input
                                    // disabled={disableFileds}
                                    disabled
                                    name="name"
                                    value={record.name}
                                    placeholder="Name" />
                            </Form.Item>
                        ),
                    },
                    {
                        title: 'Type',
                        dataIndex: 'type',
                        key: 'type',
                        render: (text, record) => (
                            <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                <Select
                                    // disabled={disableFileds}
                                    disabled
                                    placeholder="Type"
                                    name="type"
                                    value={record.type}
                                >
                                    <Option value="Product">Product</Option>
                                    <Option value="Service">Service</Option>
                                    <Option value="Staff Role">Staff Role</Option>
                                    <Option value="RFP">RFP</Option>
                                    <Option value="Others">Others</Option>
                                </Select>
                            </Form.Item>
                        ),
                    },
                    {
                        title: `Price (${latestCurrencySettings?.currency})`,
                        dataIndex: 'value',
                        key: 'value',
                        render: (text, record) => (
                            <Form.Item>
                                <Input type="text"
                                    // disabled={disableFileds}
                                    disabled
                                    prefix={latestCurrencySettings?.symbol}
                                    name="value"
                                    value={record.value}
                                    placeholder="Total" />
                            </Form.Item>
                        ),
                    },
                    {
                        title: 'Start Date',
                        dataIndex: 'startDate',
                        key: 'startDate',
                        type: 'date',
                        render: (text, record) => (
                            <Form.Item>
                                <DatePicker
                                    // disabled={disableFileds}
                                    disabled
                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                    value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                    name="startDate"
                                    disabledDate={disabledDate}
                                    placeholder="Start Date"
                                />
                            </Form.Item>
                        ),
                    },
                    {
                        title: 'End Date',
                        dataIndex: 'endDate',
                        key: 'endDate',
                        type: 'date',
                        render: (text, record) => (
                            <Form.Item>
                                <DatePicker
                                    // disabled={disableFileds}
                                    disabled
                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                    value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                    name="endDate"
                                    disabledDate={disabledDate}
                                    placeholder="End Date"
                                />
                            </Form.Item>
                        ),
                    },
                    {
                        title: `Total (${latestCurrencySettings?.currency})`,
                        dataIndex: 'total',
                        key: 'total',
                        render: (text, record,) => (
                            <Form.Item>
                                <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                    name="total"
                                    value={record.total}
                                    placeholder="Total" />
                            </Form.Item>
                        ),
                    },
                ]
            }
        }
        else if (response?.data?.subtype === "Staff Augmentation") {
            const roleValues = response?.data?.staffRoles
            const convertedRoleData = await Promise.all(
                roleValues.map(async (role) => {
                    const convertedRate = await (role.role_per_day_rate !== undefined && role.role_per_day_rate !== null && role.role_per_day_rate !== ""
                        ? ExchangeCurrency(Number(role.role_per_day_rate), ConvertRates)
                        : role.role_per_day_rate);
                    const convertedTotalValue = await (role.total_value !== undefined && role.total_value !== null && role.total_value !== ""
                        ? ExchangeCurrency(Number(role.total_value), ConvertRates)
                        : role.total_value);
                    return {
                        ItemId: role.add_staff_role_id,
                        name: role.roleName,
                        country: role.country,
                        type: "Staff Role",
                        value: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        startDate: role.start_date,
                        endDate: role.end_date,
                        total: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            result = {
                datas: {
                    type: response?.data?.subtype,
                    product: response?.data?.products,
                    service: response?.data?.service
                },
                discount: response?.data?.discount_percentage ? response?.data?.discount_percentage : 0,
                items: convertedRoleData,
                columns: [
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        key: 'name',
                        render: (text, record) => (
                            <Form.Item>
                                <Input
                                    // disabled={disableFileds}
                                    disabled
                                    name="name"
                                    value={`${record.name}, ${record.country}`}
                                    placeholder="Name"
                                />
                            </Form.Item>
                        ),
                    },
                    {
                        title: 'Type',
                        dataIndex: 'type',
                        key: 'type',
                        render: (text, record) => (
                            <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                <Select
                                    // disabled={disableFileds}
                                    disabled
                                    placeholder="Type"
                                    name="type"
                                    value={record.type}
                                >
                                    <Option value="Product">Product</Option>
                                    <Option value="Service">Service</Option>
                                    <Option value="Staff Role">Staff Role</Option>
                                    <Option value="RFP">RFP</Option>
                                    <Option value="Others">Others</Option>
                                </Select>
                            </Form.Item>
                        ),
                    },
                    {
                        title: `Price (${latestCurrencySettings?.currency})`,
                        dataIndex: 'value',
                        key: 'value',
                        render: (text, record) => (
                            <Form.Item>
                                <Input type="text"
                                    // disabled={disableFileds}
                                    disabled
                                    prefix={latestCurrencySettings?.symbol}
                                    name="value"
                                    value={record.value}
                                    placeholder="Total" />
                            </Form.Item>
                        ),
                    },
                    {
                        title: 'Start Date',
                        dataIndex: 'startDate',
                        key: 'startDate',
                        type: 'date',
                        render: (text, record) => (
                            <Form.Item>
                                <DatePicker
                                    // disabled={disableFileds}
                                    disabled
                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                    value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                    name="startDate"
                                    disabledDate={disabledDate}
                                    placeholder="Start Date"
                                />
                            </Form.Item>
                        ),
                    },
                    {
                        title: 'End Date',
                        dataIndex: 'endDate',
                        key: 'endDate',
                        type: 'date',
                        render: (text, record) => (
                            <Form.Item>
                                <DatePicker
                                    // disabled={disableFileds}
                                    disabled
                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                    value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                    name="endDate"
                                    disabledDate={disabledDate}
                                    placeholder="End Date"
                                />
                            </Form.Item>
                        ),
                    },
                    {
                        title: `Total (${latestCurrencySettings?.currency})`,
                        dataIndex: 'total',
                        key: 'total',
                        render: (text, record) => (
                            <Form.Item>
                                <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                    name="total"
                                    value={record.total}
                                    placeholder="Total" />
                            </Form.Item>
                        ),
                    },
                ]
            }
        }
        else if (response?.data?.subtype === "Request for Proposal" || response?.data?.subtype === "Product and Services") {
            if (response?.data?.products?.length === 0 && response?.data?.service?.length === 0 && response?.data?.subtype === "Request for Proposal") {
                const DealValue = response?.data?.deal_value ? await ExchangeCurrency(Number(response?.data?.deal_value), ConvertRates) : response?.data?.deal_value;
                const revenueStartDate = response?.data?.revenue_start_date !== "" && response?.data?.revenue_start_date !== null ? response?.data?.revenue_start_date : null;
                const revenueEndDate = response?.data?.revenue_end_date !== "" && response?.data?.revenue_end_date !== null ? response?.data?.revenue_end_date : null;
                result = {
                    datas: {
                        type: response?.data?.subtype,
                        product: response?.data?.products,
                        service: response?.data?.service
                    },
                    discount: response?.data?.discount_percentage ? response?.data?.discount_percentage : 0,
                    items: [{
                        ItemId: id,
                        name: "RFP",
                        type: "RFP",
                        value: DealValue,
                        startDate: revenueStartDate,
                        endDate: revenueEndDate,
                        total: DealValue
                    }],
                    columns: [
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        // disabled={disableFileds}
                                        disabled
                                        name="name"
                                        value={record.name}
                                        placeholder="Name" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                    <Select
                                        // disabled={disableFileds}
                                        disabled
                                        placeholder="Type"
                                        name="type"
                                        value={record.type}
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${latestCurrencySettings?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input type="text"
                                        // disabled={disableFileds}
                                        disabled
                                        prefix={latestCurrencySettings?.symbol}
                                        name="value"
                                        value={record.value}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Start Date',
                            dataIndex: 'startDate',
                            key: 'startDate',
                            type: 'date',
                            render: (text, record) => (
                                <Form.Item>
                                    <DatePicker
                                        // disabled={disableFileds}
                                        disabled
                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                        value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                        name="startDate"
                                        disabledDate={disabledDate}
                                        placeholder="Start Date"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'End Date',
                            dataIndex: 'endDate',
                            key: 'endDate',
                            type: 'date',
                            render: (text, record) => (
                                <Form.Item>
                                    <DatePicker
                                        // disabled={disableFileds}
                                        disabled
                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                        value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                        name="endDate"
                                        disabledDate={disabledDate}
                                        placeholder="End Date"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Total (${latestCurrencySettings?.currency})`,
                            dataIndex: 'total',
                            key: 'total',
                            render: (text, record,) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ]
                }
            }
            else if (response?.data?.products?.length > 0 || response?.data?.service?.length > 0) {
                const revenueStartDate = response?.data?.revenue_start_date !== "" && response?.data?.revenue_start_date !== null ? response?.data?.revenue_start_date : null;
                const revenueEndDate = response?.data?.revenue_end_date !== "" && response?.data?.revenue_end_date !== null ? response?.data?.revenue_end_date : null;
                if (response?.data?.products?.length > 0 && response?.data?.service?.length === 0) {
                    const convertedFormDatas = await Promise.all(
                        response?.data?.products.map(async (product) => {
                            const convertedPrice = await (product.product_license_selling_price_unitMonth !== undefined && product.product_license_selling_price_unitMonth !== '' && product.product_license_selling_price_unitMonth !== null
                                ? ExchangeCurrency(Number(product.product_license_selling_price_unitMonth), ConvertRates)
                                : product.product_license_selling_price_unitMonth);
                            const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                                ? ExchangeCurrency(Number(product.total), ConvertRates)
                                : 0);
                            return {
                                ItemId: product.deal_product_id,
                                name: product.product_name,
                                productCategory: product.product_category,
                                type: "Product",
                                value: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                                qty: product.number_of_units,
                                duration: product.license_duration,
                                total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                            };
                        })
                    );
                    result = {
                        datas: {
                            type: response?.data?.subtype,
                            product: response?.data?.products,
                            service: response?.data?.service
                        },
                        discount: response?.data?.discount_percentage ? response?.data?.discount_percentage : 0,
                        items: convertedFormDatas,
                        columns: [
                            {
                                title: 'Name',
                                dataIndex: 'name',
                                key: 'name',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input
                                            name="name"
                                            // disabled={disableFileds}
                                            disabled
                                            value={record.name}
                                            placeholder="Name"
                                        />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Type',
                                dataIndex: 'type',
                                key: 'type',
                                render: (text, record) => (
                                    <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                        <Select
                                            placeholder="Type"
                                            name="type"
                                            value={record.type}
                                            // disabled={disableFileds}
                                            disabled
                                        >
                                            <Option value="Product">Product</Option>
                                            <Option value="Service">Service</Option>
                                            <Option value="Staff Role">Staff Role</Option>
                                            <Option value="RFP">RFP</Option>
                                            <Option value="Others">Others</Option>
                                        </Select>
                                    </Form.Item>
                                ),
                            },
                            {
                                title: `Price (${latestCurrencySettings?.currency})`,
                                dataIndex: 'value',
                                key: 'value',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input type="text"
                                            // disabled={disableFileds}
                                            disabled
                                            prefix={latestCurrencySettings?.symbol}
                                            name="value"
                                            value={record.value}
                                            placeholder="Total" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Quantity',
                                dataIndex: 'qty',
                                key: 'qty',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input pattern="^\d+$" min={0}
                                            name="qty"
                                            // disabled={disableFileds}
                                            disabled
                                            value={record.qty}
                                            placeholder="Number of Units" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                                dataIndex: 'duration',
                                key: 'duration',
                                render: (text, record,) => (
                                    <Form.Item>
                                        <Input pattern="^\d+$" min={0}
                                            // disabled={disableFileds}
                                            disabled
                                            name="duration"
                                            value={record.productCategory !== "Software" ? "One off" : record.duration}
                                            placeholder="License Duration" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: `Total (${latestCurrencySettings?.currency})`,
                                dataIndex: 'total',
                                key: 'total',
                                render: (text, record,) => (
                                    <Form.Item>
                                        <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                            name="total"
                                            value={record.total}
                                            placeholder="Total" />
                                    </Form.Item>
                                ),
                            },
                        ]
                    }
                }
                if (response?.data?.products?.length === 0 && response?.data?.service?.length > 0) {
                    const convertedServicesData = await Promise.all(
                        response?.data?.service.map(async (service) => {
                            const convertedCost = await (service.service_line_cost !== undefined && service.service_line_cost !== null && service.service_line_cost !== "" ?
                                ExchangeCurrency(Number(service.service_line_cost), ConvertRates)
                                : service.service_line_cost
                            );
                            return {
                                ItemId: service.service_line_id,
                                name: service.service_name,
                                type: "Service",
                                value: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                                startDate: revenueStartDate,
                                endDate: revenueEndDate,
                                total: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                            };
                        })
                    );
                    result = {
                        datas: {
                            type: response?.data?.subtype,
                            product: response?.data?.products,
                            service: response?.data?.service
                        },
                        discount: response?.data?.discount_percentage ? response?.data?.discount_percentage : 0,
                        items: convertedServicesData,
                        columns: [
                            {
                                title: 'Name',
                                dataIndex: 'name',
                                key: 'name',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input
                                            name="name"
                                            // disabled={disableFileds}
                                            disabled
                                            value={record.name}
                                            placeholder="Name" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Type',
                                dataIndex: 'type',
                                key: 'type',
                                render: (text, record) => (
                                    <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                        <Select
                                            placeholder="Type"
                                            name="type"
                                            // disabled={disableFileds}
                                            disabled
                                            value={record.type}
                                        >
                                            <Option value="Product">Product</Option>
                                            <Option value="Service">Service</Option>
                                            <Option value="Staff Role">Staff Role</Option>
                                            <Option value="RFP">RFP</Option>
                                            <Option value="Others">Others</Option>
                                        </Select>
                                    </Form.Item>
                                ),
                            },
                            {
                                title: `Price (${latestCurrencySettings?.currency})`,
                                dataIndex: 'value',
                                key: 'value',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input type="text"
                                            // disabled={disableFileds}
                                            disabled
                                            prefix={latestCurrencySettings?.symbol}
                                            name="value"
                                            value={record.value}
                                            placeholder="Total" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Start Date',
                                dataIndex: 'startDate',
                                key: 'startDate',
                                type: 'date',
                                render: (text, record) => (
                                    <Form.Item>
                                        <DatePicker
                                            // disabled={disableFileds}
                                            disabled
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                            name="startDate"
                                            disabledDate={disabledDate}
                                            placeholder="Start Date"
                                        />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'End Date',
                                dataIndex: 'endDate',
                                key: 'endDate',
                                type: 'date',
                                render: (text, record) => (
                                    <Form.Item>
                                        <DatePicker
                                            // disabled={disableFileds}
                                            disabled
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                            name="endDate"
                                            disabledDate={disabledDate}
                                            placeholder="End Date"
                                        />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: `Total (${latestCurrencySettings?.currency})`,
                                dataIndex: 'total',
                                key: 'total',
                                render: (text, record,) => (
                                    <Form.Item>
                                        <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                            name="total"
                                            value={record.total}
                                            placeholder="Total" />
                                    </Form.Item>
                                ),
                            },
                        ]
                    }
                }
                if (response?.data?.products?.length > 0 && response?.data?.service?.length > 0) {
                    let productData = [];
                    let serviceData = [];
                    productData = await Promise.all(
                        response?.data?.products.map(async (product) => {
                            const convertedPrice = await (product.product_license_selling_price_unitMonth !== undefined && product.product_license_selling_price_unitMonth !== '' && product.product_license_selling_price_unitMonth !== null
                                ? ExchangeCurrency(Number(product.product_license_selling_price_unitMonth), ConvertRates)
                                : product.product_license_selling_price_unitMonth);
                            const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                                ? ExchangeCurrency(Number(product.total), ConvertRates)
                                : 0);
                            return {
                                ItemId: product.deal_product_id,
                                name: product.product_name,
                                productCategory: product.product_category,
                                type: "Product",
                                value: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                                qty: product.number_of_units,
                                duration: product.license_duration,
                                total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                            };
                        })
                    );
                    serviceData = await Promise.all(
                        response?.data?.service.map(async (service) => {
                            const convertedCost = await (service.service_line_cost !== undefined && service.service_line_cost !== null && service.service_line_cost !== "" ?
                                ExchangeCurrency(Number(service.service_line_cost), ConvertRates)
                                : service.service_line_cost
                            );
                            return {
                                ItemId: service.service_line_id,
                                name: service.service_name,
                                type: "Service",
                                value: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                                startDate: revenueStartDate,
                                endDate: revenueEndDate,
                                total: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                            };
                        })
                    );
                    const combineData = [...productData, ...serviceData];
                    result = {
                        datas: {
                            type: response?.data?.subtype,
                            product: response?.data?.products,
                            service: response?.data?.service
                        },
                        discount: response?.data?.discount_percentage ? response?.data?.discount_percentage : 0,
                        items: combineData,
                        columns: [
                            {
                                title: 'Name',
                                dataIndex: 'name',
                                key: 'name',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input
                                            name="name"
                                            // disabled={disableFileds}
                                            disabled
                                            value={record.name}
                                            placeholder="Name"
                                        />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Type',
                                dataIndex: 'type',
                                key: 'type',
                                render: (text, record) => (
                                    <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                        <Select
                                            placeholder="Type"
                                            name="type"
                                            // disabled={disableFileds}
                                            disabled
                                            value={record.type}
                                        >
                                            <Option value="Product">Product</Option>
                                            <Option value="Service">Service</Option>
                                            <Option value="Staff Role">Staff Role</Option>
                                            <Option value="RFP">RFP</Option>
                                            <Option value="Others">Others</Option>
                                        </Select>
                                    </Form.Item>
                                ),
                            },
                            {
                                title: `Price (${latestCurrencySettings?.currency})`,
                                dataIndex: 'value',
                                key: 'value',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input type="text"
                                            // disabled={disableFileds}
                                            disabled
                                            prefix={latestCurrencySettings?.symbol}
                                            name="value"
                                            value={record.value}
                                            placeholder="Total" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Quantity',
                                dataIndex: 'qty',
                                key: 'qty',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input pattern="^\d+$" min={0}
                                            name="qty"
                                            // disabled={disableFileds}
                                            disabled
                                            value={record.qty}
                                            placeholder="Quantity" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                                dataIndex: 'duration',
                                key: 'duration',
                                render: (text, record,) => (
                                    <Form.Item>
                                        <Input pattern="^\d+$" min={0}
                                            name="duration"
                                            // disabled={disableFileds}
                                            disabled
                                            value={record.productCategory !== "Software" ? "One off" : record.duration}
                                            placeholder="License Duration" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Start Date',
                                dataIndex: 'startDate',
                                key: 'startDate',
                                type: 'date',
                                render: (text, record) => (
                                    <Form.Item>
                                        <DatePicker
                                            // disabled={disableFileds}
                                            disabled
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                            name="startDate"
                                            disabledDate={disabledDate}
                                            placeholder="Start Date"
                                        />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'End Date',
                                dataIndex: 'endDate',
                                key: 'endDate',
                                type: 'date',
                                render: (text, record) => (
                                    <Form.Item>
                                        <DatePicker
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                            name="endDate"
                                            // disabled={disableFileds}
                                            disabled
                                            disabledDate={disabledDate}
                                            placeholder="End Date"
                                        />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: `Total (${latestCurrencySettings?.currency})`,
                                dataIndex: 'Total',
                                key: 'total',
                                render: (text, record,) => (
                                    <Form.Item>
                                        <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                            name="total"
                                            value={record.total}
                                            placeholder="Total" />
                                    </Form.Item>
                                ),
                            },
                        ]
                    }
                }
            }
        }
    } catch (error) {
        message.error(error);
    }
    return result
}
export async function getDealDatabyAccount(value, id) {
    const DealList = await FetchDealByAccount(value)
    const updatedContactList = [...DealList];
    if (id) {
        const isAlreadyIncluded = updatedContactList.some(
            deal => deal.deals_id === id
        );
        if (!isAlreadyIncluded) {
            try {
                const parentDealResponse = await FetchDealDetails(id);
                if (parentDealResponse?.data) {
                    updatedContactList.push(parentDealResponse.data);
                }
            } catch (err) {
                message.error(`Failed to fetch parent deal: ${err}`);
            }
        }
    }
    const options = updatedContactList.filter(option =>
        ["Proposal", "Negotiation", "Won", "on-Hold", "On-Hold"].includes(option.pipelineStage)
    ).map((option, i) => (
        <Option value={option.deals_id} key={i} label={(
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className='Div_flex2'>
                    <div className='share_image' title={`${option.deal_name} (${option.pipelineStage})`} style={{ cursor: "default" }}>
                        {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                            < img src={option.deal_profile} alt="profile" />
                            :
                            <span className="image_icon DealIcon">
                                {option.deal_name.slice(0, 1).toUpperCase()}
                            </span>
                        }
                        <span className='div-ellipsis'>{option.deal_name}</span>
                    </div>
                </div>
            </div>)}>
            <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                <div>
                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                        < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                        :
                        <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                            {option.deal_name.slice(0, 1).toUpperCase()}
                        </span>
                    }</div>
                <div>
                    <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                    <p style={{ margin: 0 }}>{option.pipelineStage}</p>
                </div>
            </div>
        </Option>));
    return options;
}
export async function getContactDatabyAccount(value, id) {
    try {
        const data = await FetchContactByDeal(value)
        const updatedContactList = [...data];
        if (id) {
            const isPresent = updatedContactList.some(contact => contact.contacts_id === id);
            if (!isPresent) {
                try {
                    const responseData = await FetchContactDetails(id)
                    if (responseData?.data) {
                        updatedContactList.push(responseData.data);
                    }
                } catch (err) {
                    message.error(err)
                }
            }
        }
        const options = updatedContactList.map((option, i) => (
            <Option value={option.contacts_id} key={i} label={(
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div className='Div_flex2'>
                        <div className='share_image' title={`${option.first_name} ${option.last_name} (${option.email})`} style={{ cursor: "default" }}>
                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                < img src={option.contact_profile} alt="profile" />
                                :
                                <span className="image_icon ContactIcon">
                                    {option.first_name.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <span className='div-ellipsis'>{`${option.first_name} ${option.last_name}`}</span>
                        </div>
                    </div>
                </div>)} >
                <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                    <div>
                        {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                            < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                            :
                            <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                {option.first_name.slice(0, 1).toUpperCase()}
                            </span>
                        }</div>
                    <div>
                        <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                        <p style={{ margin: 0 }}>{option.email}</p>
                    </div>
                </div>
            </Option>))
        return options;
    } catch (error) { message.error(error) }
}
export async function QuotesItemListColumn(item, profile, disabledDate, latestCurrencySettings, page, convertedRoleData, removeItem, handleTableItem, errors, validateDate, edit) {
    let result;
    switch (item.type) {
        case "Others":
            result = [
                {
                    title: 'Name',
                    dataIndex: 'name',
                    key: 'name',
                    render: (text, record) => (
                        <Form.Item>
                            <Input
                                // disabled={disableFileds}
                                disabled
                                name="name"
                                value={record.name}
                                placeholder="Name" />
                        </Form.Item>
                    ),
                },
                {
                    title: 'Type',
                    dataIndex: 'type',
                    key: 'type',
                    render: (text, record) => (
                        <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                            <Select
                                // disabled={disableFileds}
                                disabled
                                placeholder="Type"
                                name="type"
                                value={record.type}
                            >
                                <Option value="Product">Product</Option>
                                <Option value="Service">Service</Option>
                                <Option value="Staff Role">Staff Role</Option>
                                <Option value="RFP">RFP</Option>
                                <Option value="Others">Others</Option>
                            </Select>
                        </Form.Item>
                    ),
                },
                {
                    title: `Price (${latestCurrencySettings?.currency})`,
                    dataIndex: 'value',
                    key: 'value',
                    render: (text, record, index) => (
                        <>
                            <Form.Item >
                                <Input type="text"
                                    disabled={!(page === "Invoice" && edit)}
                                    prefix={latestCurrencySettings?.symbol}
                                    name="value"
                                    value={record.value}
                                    onChange={(e) => {
                                        if (page === "Invoice") {
                                            const inputValue = e.target.value;
                                            const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                            const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                            if (inputValue?.toString()?.length > 25) {
                                                message.error('Maximum 25 characters allowed');
                                                return;
                                            }
                                            if (!basicNumberCheck) {
                                                message.error('Please enter a valid number');
                                                return;
                                            }
                                            if (inputValue === ".") {
                                                message.error('Please enter a valid number');
                                                return;
                                            }
                                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                            if (inputValue && !decimalRegex.test(inputValue)) {
                                                message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                return;
                                            }
                                            handleTableItem(index, 'value', e.target.value, convertedRoleData, "Others", record.ItemId);
                                            validateDate(e.target.value, index, 'value');
                                        }
                                    }}
                                    placeholder="Total" />
                            </Form.Item>
                            {page === "Invoice" && errors[`value-${index}`] && (
                                <span style={{ color: 'red', fontSize: '12px' }}>
                                    Price is required!
                                </span>
                            )}
                        </>
                    ),
                },
                {
                    title: 'Start Date',
                    dataIndex: 'startDate',
                    key: 'startDate',
                    type: 'date',
                    render: (text, record, index) => (
                        <>
                            <Form.Item>
                                <DatePicker disabled={!(page === "Invoice" && edit)}
                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                    value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                    name="startDate"
                                    required
                                    disabledDate={(current) => {
                                        const endDate = record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null;
                                        return current && endDate && current.isAfter(endDate, 'day');
                                    }}
                                    placeholder="Start Date"
                                    onChange={(date, dateString) => {
                                        if (page === "Invoice") {
                                            handleTableItem(index, 'startDate', dateString, convertedRoleData, "Others", record.ItemId);
                                            validateDate(dateString, index, 'startDate');
                                        }
                                    }}
                                />
                            </Form.Item>
                            {page === "Invoice" && errors[`startDate-${index}`] && (
                                <span style={{ color: 'red', fontSize: '12px' }}>
                                    Start Date is required!
                                </span>
                            )}
                        </>
                    )
                },
                {
                    title: 'End Date',
                    dataIndex: 'endDate',
                    key: 'endDate',
                    type: 'date',
                    render: (text, record, index) => (
                        <>
                            <Form.Item >
                                <DatePicker
                                    disabled={!(page === "Invoice" && edit)}
                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                    value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                    name="endDate"
                                    disabledDate={(current) => {
                                        const startDate = record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null;
                                        return current && startDate && current.isBefore(startDate, 'day');
                                    }}
                                    placeholder="End Date"
                                    onChange={(date, dateString) => {
                                        if (page === "Invoice") {
                                            handleTableItem(index, 'endDate', dateString, convertedRoleData, "Others", record.ItemId)
                                            validateDate(dateString, index, 'endDate');
                                        }
                                    }}
                                />
                            </Form.Item>
                            {page === "Invoice" && errors[`endDate-${index}`] && (
                                <span style={{ color: 'red', fontSize: '12px' }}>
                                    End Date is required!
                                </span>
                            )}
                        </>
                    ),
                },
                {
                    title: `Total (${latestCurrencySettings?.currency})`,
                    dataIndex: 'total',
                    key: 'total',
                    render: (text, record,) => (
                        <Form.Item>
                            <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                name="total"
                                value={record.total}
                                placeholder="Total" />
                        </Form.Item>
                    ),
                },
            ];
            break;
        case "Staff Augmentation":
            result = [
                {
                    title: 'Name',
                    dataIndex: 'name',
                    key: 'name',
                    render: (text, record) => (
                        <Form.Item>
                            <Input
                                // disabled={disableFileds}
                                disabled
                                name="name"
                                value={`${record.name}, ${record.country}`}
                                placeholder="Name"
                            />
                        </Form.Item>
                    ),
                },
                {
                    title: 'Type',
                    dataIndex: 'type',
                    key: 'type',
                    render: (text, record) => (
                        <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                            <Select
                                // disabled={disableFileds}
                                disabled
                                placeholder="Type"
                                name="type"
                                value={record.type}
                            >
                                <Option value="Product">Product</Option>
                                <Option value="Service">Service</Option>
                                <Option value="Staff Role">Staff Role</Option>
                                <Option value="RFP">RFP</Option>
                                <Option value="Others">Others</Option>
                            </Select>
                        </Form.Item>
                    ),
                },
                {
                    title: `Price (${latestCurrencySettings?.currency})`,
                    dataIndex: 'value',
                    key: 'value',
                    render: (text, record) => (
                        <Form.Item>
                            <Input type="text"
                                // disabled={disableFileds}
                                disabled
                                prefix={latestCurrencySettings?.symbol}
                                name="value"
                                value={record.value}
                                placeholder="Total" />
                        </Form.Item>
                    ),
                },
                {
                    title: 'Start Date',
                    dataIndex: 'startDate',
                    key: 'startDate',
                    type: 'date',
                    render: (text, record, index) => (
                        <>
                            <Form.Item>
                                <DatePicker
                                    disabled={!(page === "Invoice" && edit)}
                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                    value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                    name="startDate"
                                    disabledDate={(current) => {
                                        const endDate = record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null;
                                        return current && endDate && current.isAfter(endDate, 'day');
                                    }}
                                    placeholder="Start Date"
                                    onChange={(date, dateString) => {
                                        if (page === "Invoice") {
                                            handleTableItem(index, 'startDate', dateString, convertedRoleData, "StaffAug", record.ItemId)
                                            validateDate(dateString, index, 'startDate');
                                        }
                                    }}
                                />
                            </Form.Item>
                            {page === "Invoice" && errors[`startDate-${index}`] && (
                                <span style={{ color: 'red', fontSize: '12px' }}>
                                    Start Date is required!
                                </span>
                            )}
                        </>
                    ),
                },
                {
                    title: 'End Date',
                    dataIndex: 'endDate',
                    key: 'endDate',
                    type: 'date',
                    render: (text, record, index) => (
                        <>
                            <Form.Item >
                                <DatePicker
                                    disabled={!(page === "Invoice" && edit)}
                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                    value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                    name="endDate"
                                    disabledDate={(current) => {
                                        const startDate = record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null;
                                        return current && startDate && current.isBefore(startDate, 'day');
                                    }}
                                    placeholder="End Date"
                                    onChange={(date, dateString) => {
                                        if (page === "Invoice") {
                                            handleTableItem(index, 'endDate', dateString, convertedRoleData, "StaffAug", record.ItemId)
                                            validateDate(dateString, index, 'endDate');
                                        }
                                    }}
                                />
                            </Form.Item>
                            {page === "Invoice" && errors[`endDate-${index}`] && (
                                <span style={{ color: 'red', fontSize: '12px' }}>
                                    End Date is required!
                                </span>
                            )}
                        </>
                    ),
                },
                {
                    title: `Total (${latestCurrencySettings?.currency})`,
                    dataIndex: 'total',
                    key: 'total',
                    render: (text, record) => (
                        <Form.Item>
                            <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                name="total"
                                value={record.total}
                                placeholder="Total" />
                        </Form.Item>
                    ),
                },
            ];
            break;
        case "Request for Proposal":
            if (item?.product?.length === 0 && item?.service?.length === 0 && item?.type === "Request for Proposal") {
                result = [
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        key: 'name',
                        render: (text, record) => (
                            <Form.Item>
                                <Input
                                    // disabled={disableFileds}
                                    disabled
                                    name="name"
                                    value={record.name}
                                    placeholder="Name" />
                            </Form.Item>
                        ),
                    },
                    {
                        title: 'Type',
                        dataIndex: 'type',
                        key: 'type',
                        render: (text, record) => (
                            <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                <Select
                                    // disabled={disableFileds}
                                    disabled
                                    placeholder="Type"
                                    name="type"
                                    value={record.type}
                                >
                                    <Option value="Product">Product</Option>
                                    <Option value="Service">Service</Option>
                                    <Option value="Staff Role">Staff Role</Option>
                                    <Option value="RFP">RFP</Option>
                                    <Option value="Others">Others</Option>
                                </Select>
                            </Form.Item>
                        ),
                    },
                    {
                        title: `Price (${latestCurrencySettings?.currency})`,
                        dataIndex: 'value',
                        key: 'value',
                        render: (text, record, index) => (
                            <>
                                <Form.Item >
                                    <Input type="text"
                                        disabled={!(page === "Invoice" && edit)}
                                        prefix={latestCurrencySettings?.symbol}
                                        name="value"
                                        value={record.value}
                                        placeholder="Total"
                                        onChange={(e) => {
                                            if (page === "Invoice") {
                                                const inputValue = e.target.value;
                                                const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                if (inputValue?.toString()?.length > 25) {
                                                    message.error('Maximum 25 characters allowed');
                                                    return;
                                                }
                                                if (!basicNumberCheck) {
                                                    message.error('Please enter a valid number');
                                                    return;
                                                }
                                                if (inputValue === ".") {
                                                    message.error('Please enter a valid number');
                                                    return;
                                                }
                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                    message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                    return;
                                                }
                                                handleTableItem(index, 'value', e.target.value, convertedRoleData, "RFP", record.ItemId);
                                                validateDate(e.target.value, index, 'value');
                                            }
                                        }}
                                    />
                                </Form.Item>
                                {page === "Invoice" && errors[`value-${index}`] && (
                                    <span style={{ color: 'red', fontSize: '12px' }}>
                                        Price is required!
                                    </span>
                                )}
                            </>
                        ),
                    },
                    {
                        title: 'Start Date',
                        dataIndex: 'startDate',
                        key: 'startDate',
                        type: 'date',
                        render: (text, record, index) => (
                            <>
                                <Form.Item >
                                    <DatePicker
                                        disabled={!(page === "Invoice" && edit)}
                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                        value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                        name="startDate"
                                        disabledDate={(current) => {
                                            const endDate = record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null;
                                            return current && endDate && current.isAfter(endDate, 'day');
                                        }}
                                        placeholder="Start Date"
                                        onChange={(date, dateString) => {
                                            if (page === "Invoice") {
                                                handleTableItem(index, 'startDate', dateString, convertedRoleData, "RFP", record.ItemId)
                                                validateDate(dateString, index, 'startDate');
                                            }
                                        }}
                                    />
                                </Form.Item>
                                {page === "Invoice" && errors[`startDate-${index}`] && (
                                    <span style={{ color: 'red', fontSize: '12px' }}>
                                        Start Date is required!
                                    </span>
                                )}
                            </>
                        ),
                    },
                    {
                        title: 'End Date',
                        dataIndex: 'endDate',
                        key: 'endDate',
                        type: 'date',
                        render: (text, record, index) => (
                            <>
                                <Form.Item >
                                    <DatePicker
                                        disabled={!(page === "Invoice" && edit)}
                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                        value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                        name="endDate"
                                        disabledDate={(current) => {
                                            const startDate = record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null;
                                            return current && startDate && current.isBefore(startDate, 'day');
                                        }}
                                        placeholder="End Date"
                                        onChange={(date, dateString) => {
                                            if (page === "Invoice") {
                                                handleTableItem(index, 'endDate', dateString, convertedRoleData, "RFP", record.ItemId)
                                                validateDate(dateString, index, 'endDate');
                                            }
                                        }}
                                    />
                                </Form.Item>{page === "Invoice" && errors[`endDate-${index}`] && (
                                    <span style={{ color: 'red', fontSize: '12px' }}>
                                        End Date is required!
                                    </span>
                                )}
                            </>
                        ),
                    },
                    {
                        title: `Total (${latestCurrencySettings?.currency})`,
                        dataIndex: 'total',
                        key: 'total',
                        render: (text, record,) => (
                            <Form.Item>
                                <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                    name="total"
                                    value={record.total}
                                    placeholder="Total" />
                            </Form.Item>
                        ),
                    },
                ]
            } else if (item?.product?.length > 0 || item?.service?.length > 0) {
                if (item?.product?.length > 0 && item?.service?.length === 0) {
                    result = [
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        name="name"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.name}
                                        placeholder="Name"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                    <Select
                                        placeholder="Type"
                                        name="type"
                                        value={record.type}
                                        // disabled={disableFileds}
                                        disabled
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${latestCurrencySettings?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input type="text"
                                        disabled
                                        prefix={latestCurrencySettings?.symbol}
                                        name="value"
                                        value={record.value}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Quantity',
                            dataIndex: 'qty',
                            key: 'qty',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <Input pattern="^\d+$" min={0}
                                            name="qty"
                                            disabled={!(page === "Invoice" && edit)}
                                            value={record.qty}
                                            placeholder="Number of Units"
                                            onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'qty', e.target.value, convertedRoleData, "Product", record.ItemId);
                                                    validateDate(e.target.value, index, 'qty');
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`qty-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Quantity is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                            dataIndex: 'duration',
                            key: 'duration',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <Input pattern="^\d+$" min={0}
                                            disabled={!(page === "Invoice" && edit && (record.productCategory === "Software" || page !== "Invoice"))}
                                            name="duration"
                                            value={record.productCategory !== "Software" ? "One off" : record.duration}
                                            placeholder="License Duration" onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'duration', e.target.value, convertedRoleData, "Product", record.ItemId);
                                                    validateDate(e.target.value, index, 'duration');
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`duration-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Duration is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: `Total (${latestCurrencySettings?.currency})`,
                            dataIndex: 'total',
                            key: 'total',
                            render: (text, record,) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ]
                }
                if (item?.product?.length === 0 && item?.service?.length > 0) {
                    result = [
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        name="name"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.name}
                                        placeholder="Name" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                    <Select
                                        placeholder="Type"
                                        name="type"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.type}
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${latestCurrencySettings?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item>
                                        <Input type="text"
                                            disabled={!(page === "Invoice" && edit)}
                                            prefix={latestCurrencySettings?.symbol}
                                            name="value"
                                            value={record.value}
                                            placeholder="Total"
                                            onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'value', e.target.value, convertedRoleData, "Service", record.ItemId);
                                                    validateDate(e.target.value, index, 'value');
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`value-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Price is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'Start Date',
                            dataIndex: 'startDate',
                            key: 'startDate',
                            type: 'date',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <DatePicker
                                            disabled={!(page === "Invoice" && edit)}
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                            name="startDate"
                                            disabledDate={(current) => {
                                                const endDate = record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null;
                                                return current && endDate && current.isAfter(endDate, 'day');
                                            }}
                                            placeholder="Start Date"
                                            onChange={(date, dateString) => {
                                                if (page === "Invoice") {
                                                    handleTableItem(index, 'startDate', dateString, convertedRoleData, "Service", record.ItemId)
                                                    validateDate(dateString, index, 'startDate');
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`startDate-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Start Date is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'End Date',
                            dataIndex: 'endDate',
                            key: 'endDate',
                            type: 'date',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <DatePicker
                                            disabled={!(page === "Invoice" && edit)}
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                            name="endDate"
                                            disabledDate={(current) => {
                                                const startDate = record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null;
                                                return current && startDate && current.isBefore(startDate, 'day');
                                            }}
                                            placeholder="End Date"
                                            onChange={(date, dateString) => {
                                                if (page === "Invoice") {
                                                    handleTableItem(index, 'endDate', dateString, convertedRoleData, "Service", record.ItemId)
                                                    validateDate(dateString, index, 'endDate');
                                                }
                                            }}
                                        />
                                    </Form.Item> {page === "Invoice" && errors[`endDate-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            End Date is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: `Total (${latestCurrencySettings?.currency})`,
                            dataIndex: 'total',
                            key: 'total',
                            render: (text, record,) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ]
                }
                if (item?.product?.length > 0 && item?.service?.length > 0) {
                    result = [
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        name="name"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.name}
                                        placeholder="Name"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                    <Select
                                        placeholder="Type"
                                        name="type"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.type}
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${latestCurrencySettings?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item>
                                        <Input type="text"
                                            disabled={!(page === "Invoice" && edit && record.type !== "Product")}
                                            prefix={latestCurrencySettings?.symbol}
                                            name="value"
                                            value={record.value}
                                            placeholder="Total" onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'value', e.target.value, convertedRoleData, "Service", record.ItemId);
                                                    if ((page === "Invoice" && record.type !== "Product")) {
                                                        validateDate(e.target.value, index, 'value');
                                                    }
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`value-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Price is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'Quantity',
                            dataIndex: 'qty',
                            key: 'qty',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <Input pattern="^\d+$" min={0}
                                            name="qty"
                                            disabled={!(page === "Invoice" && edit && record.type !== "Service")}
                                            value={record.qty}
                                            placeholder="Quantity" onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'qty', e.target.value, convertedRoleData, "Product", record.ItemId);
                                                    if ((page === "Invoice" && record.type !== "Service")) {
                                                        validateDate(e.target.value, index, 'qty');
                                                    }
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`qty-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Quantity is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                            dataIndex: 'duration',
                            key: 'duration',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <Input pattern="^\d+$" min={0}
                                            name="duration"
                                            disabled={!(page === "Invoice" && edit && record.type !== "Service" && record.productCategory === "Software")}
                                            value={record.productCategory !== "Software" ? "One off" : record.duration}
                                            placeholder="License Duration" onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'duration', e.target.value, convertedRoleData, "Product", record.ItemId);
                                                    if ((page === "Invoice" && record.type !== "Service" && record.productCategory === "Software")) {
                                                        validateDate(e.target.value, index, 'duration');
                                                    }
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`duration-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Duration is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'Start Date',
                            dataIndex: 'startDate',
                            key: 'startDate',
                            type: 'date',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <DatePicker
                                            disabled={!(page === "Invoice" && edit && record.type !== "Product")}
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                            name="startDate"
                                            disabledDate={(current) => {
                                                const endDate = record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null;
                                                return current && endDate && current.isAfter(endDate, 'day');
                                            }}
                                            placeholder="Start Date" onChange={(date, dateString) => {
                                                if (page === "Invoice") {
                                                    handleTableItem(index, 'startDate', dateString, convertedRoleData, "Service", record.ItemId)
                                                    if ((page === "Invoice" && record.type !== "Product")) {
                                                        validateDate(dateString, index, 'startDate');
                                                    }
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`startDate-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Start Date is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'End Date',
                            dataIndex: 'endDate',
                            key: 'endDate',
                            type: 'date',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <DatePicker
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                            name="endDate"
                                            disabled={!(page === "Invoice" && edit && record.type !== "Product")}
                                            disabledDate={(current) => {
                                                const startDate = record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null;
                                                return current && startDate && current.isBefore(startDate, 'day');
                                            }}
                                            placeholder="End Date" onChange={(date, dateString) => {
                                                if (page === "Invoice") {
                                                    handleTableItem(index, 'endDate', dateString, convertedRoleData, "Service", record.ItemId)
                                                    if ((page === "Invoice" && record.type !== "Product")) {
                                                        validateDate(dateString, index, 'endDate');
                                                    }
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`endDate-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            End Date is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: `Total (${latestCurrencySettings?.currency})`,
                            dataIndex: 'Total',
                            key: 'total',
                            render: (text, record,) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ]
                }
            }
            break;
        case "Product and Services":
            if (item?.product?.length > 0 || item?.service?.length > 0) {
                if (item?.product?.length > 0 && item?.service?.length === 0) {
                    result = [
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        name="name"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.name}
                                        placeholder="Name"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                    <Select
                                        placeholder="Type"
                                        name="type"
                                        value={record.type}
                                        // disabled={disableFileds}
                                        disabled
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${latestCurrencySettings?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input type="text"
                                        // disabled={disableFileds}
                                        disabled
                                        prefix={latestCurrencySettings?.symbol}
                                        name="value"
                                        value={record.value}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Quantity',
                            dataIndex: 'qty',
                            key: 'qty',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <Input pattern="^\d+$" min={0}
                                            name="qty"
                                            disabled={!(page === "Invoice" && edit)}
                                            value={record.qty}
                                            placeholder="Number of Units"
                                            onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'qty', e.target.value, convertedRoleData, "Product", record.ItemId);
                                                    validateDate(e.target.value, index, 'qty');
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`qty-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Quantity is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                            dataIndex: 'duration',
                            key: 'duration',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <Input pattern="^\d+$" min={0}
                                            disabled={!(page === "Invoice" && edit && (record.productCategory === "Software" || page !== "Invoice"))}
                                            name="duration"
                                            value={record.duration}
                                            placeholder="License Duration" onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'duration', e.target.value, convertedRoleData, "Product", record.ItemId);
                                                    validateDate(e.target.value, index, 'duration');
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`duration-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Duration is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: `Total (${latestCurrencySettings?.currency})`,
                            dataIndex: 'total',
                            key: 'total',
                            render: (text, record,) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ]
                }
                if (item?.product?.length === 0 && item?.service?.length > 0) {
                    result = [
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        name="name"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.name}
                                        placeholder="Name" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '150px', minWidth: '150px' }}>
                                    <Select
                                        placeholder="Type"
                                        name="type"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.type}
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${latestCurrencySettings?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item>
                                        <Input type="text"
                                            disabled={!(page === "Invoice" && edit)}
                                            prefix={latestCurrencySettings?.symbol}
                                            name="value"
                                            value={record.value}
                                            placeholder="Total"
                                            onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'value', e.target.value, convertedRoleData, "Service", record.ItemId);
                                                    validateDate(e.target.value, index, 'value');
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`value-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Price is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'Start Date',
                            dataIndex: 'startDate',
                            key: 'startDate',
                            type: 'date',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <DatePicker
                                            disabled={!(page === "Invoice" && edit)}
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                            name="startDate"
                                            disabledDate={(current) => {
                                                const endDate = record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null;
                                                return current && endDate && current.isAfter(endDate, 'day');
                                            }}
                                            placeholder="Start Date"
                                            onChange={(date, dateString) => {
                                                if (page === "Invoice") {
                                                    handleTableItem(index, 'startDate', dateString, convertedRoleData, "Service", record.ItemId)
                                                    validateDate(dateString, index, 'startDate');
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`startDate-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Start Date is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'End Date',
                            dataIndex: 'endDate',
                            key: 'endDate',
                            type: 'date',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <DatePicker
                                            disabled={!(page === "Invoice" && edit)}
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                            name="endDate"
                                            disabledDate={(current) => {
                                                const startDate = record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null;
                                                return current && startDate && current.isBefore(startDate, 'day');
                                            }}
                                            placeholder="End Date"
                                            onChange={(date, dateString) => {
                                                if (page === "Invoice") {
                                                    handleTableItem(index, 'endDate', dateString, convertedRoleData, "Service", record.ItemId)
                                                    validateDate(dateString, index, 'endDate');
                                                }
                                            }}
                                        />
                                    </Form.Item> {page === "Invoice" && errors[`endDate-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            End Date is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: `Total (${latestCurrencySettings?.currency})`,
                            dataIndex: 'total',
                            key: 'total',
                            render: (text, record,) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ]
                }
                if (item?.product?.length > 0 && item?.service?.length > 0) {
                    result = [
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        name="name"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.name}
                                        placeholder="Name"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '100px', minWidth: '100px' }}>
                                    <Select
                                        placeholder="Type"
                                        name="type"
                                        // disabled={disableFileds}
                                        disabled
                                        value={record.type}
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${latestCurrencySettings?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item>
                                        <Input type="text"
                                            disabled={!(page === "Invoice" && edit && record.type !== "Product")}
                                            prefix={latestCurrencySettings?.symbol}
                                            name="value"
                                            value={record.value}
                                            placeholder="Total" onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'value', e.target.value, convertedRoleData, "Service", record.ItemId);
                                                    if ((page === "Invoice" && record.type !== "Product")) {
                                                        validateDate(e.target.value, index, 'value');
                                                    }
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`value-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Price is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'Quantity',
                            dataIndex: 'qty',
                            key: 'qty',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item>
                                        <Input pattern="^\d+$" min={0}
                                            name="qty"
                                            disabled={!(page === "Invoice" && edit && record.type !== "Service")}
                                            value={record.qty}
                                            placeholder="Quantity" onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'qty', e.target.value, convertedRoleData, "Product", record.ItemId);
                                                    if ((page === "Invoice" && record.type !== "Service")) {
                                                        validateDate(e.target.value, index, 'qty');
                                                    }
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`qty-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Quantity is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                            dataIndex: 'duration',
                            key: 'duration',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <Input pattern="^\d+$" min={0}
                                            name="duration"
                                            disabled={!(page === "Invoice" && edit && record.type !== "Service" && record.productCategory === "Software")}
                                            value={record.duration}
                                            placeholder="License Duration" onChange={(e) => {
                                                if (page === "Invoice") {
                                                    const inputValue = e.target.value;
                                                    const decimalLimit = latestCurrencySettings?.decimalOfCurrency || 2;
                                                    const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                    if (inputValue?.toString()?.length > 25) {
                                                        message.error('Maximum 25 characters allowed');
                                                        return;
                                                    }
                                                    if (!basicNumberCheck) {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    if (inputValue === ".") {
                                                        message.error('Please enter a valid number');
                                                        return;
                                                    }
                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                    if (inputValue && !decimalRegex.test(inputValue)) {
                                                        message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                        return;
                                                    }
                                                    handleTableItem(index, 'duration', e.target.value, convertedRoleData, "Product", record.ItemId);
                                                    if ((page === "Invoice" && record.type !== "Service" && record.productCategory === "Software")) {
                                                        validateDate(e.target.value, index, 'duration');
                                                    }
                                                }
                                            }} />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`duration-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Duration is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'Start Date',
                            dataIndex: 'startDate',
                            key: 'startDate',
                            type: 'date',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <DatePicker
                                            disabled={!(page === "Invoice" && edit && record.type !== "Product")}
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                            name="startDate"
                                            disabledDate={(current) => {
                                                const endDate = record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null;
                                                return current && endDate && current.isAfter(endDate, 'day');
                                            }}
                                            placeholder="Start Date" onChange={(date, dateString) => {
                                                if (page === "Invoice") {
                                                    handleTableItem(index, 'startDate', dateString, convertedRoleData, "Service", record.ItemId)
                                                    if ((page === "Invoice" && record.type !== "Product")) {
                                                        validateDate(dateString, index, 'startDate');
                                                    }
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`startDate-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            Start Date is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: 'End Date',
                            dataIndex: 'endDate',
                            key: 'endDate',
                            type: 'date',
                            render: (text, record, index) => (
                                <>
                                    <Form.Item >
                                        <DatePicker
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                            name="endDate"
                                            disabled={!(page === "Invoice" && edit && record.type !== "Product")}
                                            disabledDate={(current) => {
                                                const startDate = record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null;
                                                return current && startDate && current.isBefore(startDate, 'day');
                                            }}
                                            placeholder="End Date" onChange={(date, dateString) => {
                                                if (page === "Invoice") {
                                                    handleTableItem(index, 'endDate', dateString, convertedRoleData, "Service", record.ItemId)
                                                    if ((page === "Invoice" && record.type !== "Product")) {
                                                        validateDate(dateString, index, 'endDate');
                                                    }
                                                }
                                            }}
                                        />
                                    </Form.Item>
                                    {page === "Invoice" && errors[`endDate-${index}`] && (
                                        <span style={{ color: 'red', fontSize: '12px' }}>
                                            End Date is required!
                                        </span>
                                    )}
                                </>
                            ),
                        },
                        {
                            title: `Total (${latestCurrencySettings?.currency})`,
                            dataIndex: 'Total',
                            key: 'total',
                            render: (text, record,) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={latestCurrencySettings?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ]
                }
            }
            break;
        default:
            result = [
                {
                    title: 'Name',
                    dataIndex: 'Name',
                    key: 'Name',
                },
                {
                    title: 'Type',
                    dataIndex: 'Type',
                    key: 'Type',
                },
                {
                    title: `Price (${latestCurrencySettings?.currency})`,
                    dataIndex: 'Price',
                    key: 'Price',
                },
                {
                    title: 'Quantity',
                    dataIndex: 'Quantity',
                    key: 'Quantity',
                },
                {
                    title: 'Start Date',
                    dataIndex: 'StartDate',
                    key: 'StartDate',
                },
                {
                    title: 'End Date',
                    dataIndex: 'EndDate',
                    key: 'EndDate',
                },
                {
                    title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                    dataIndex: 'Duration',
                    key: 'Duration',
                },
                {
                    title: `Total (${latestCurrencySettings?.currency})`,
                    dataIndex: 'Total',
                    key: 'Total',
                },
            ];
    }
    if (page === "Invoice") {
        result.push({
            title: '',
            dataIndex: 'action',
            key: 'action',
            render: (text, record, index) => {
                if (edit && convertedRoleData.length > 0) {
                    return (
                        <Form.Item>
                            <FeatherIcon icon="trash-2" size={20} className="fetcherDelete-Icon" style={{ margin: "0px" }}
                                onClick={() => removeItem(index, convertedRoleData)}
                            />
                        </Form.Item>
                    );
                }
            },
        })
    }
    return result;
}
